import type { IconData } from '@stacksjs/iconify-core'

export const squareF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 .565h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default squareF
